export const validateGameTipData = (values, {translate}) => {
  const errors = {};
  if (!values.images || values.images.length === 0) {
    errors.images = translate("resources.gametips.validation.images");
  }
  if (!values.title || values.title.trim() === "") {
    errors.title = translate("resources.gametips.validation.title");
  }
  if (!values.author || values.author.trim() === "") {
    errors.author = translate("resources.gametips.validation.author");
  }
  if (!values.date || values.date.trim() === "") {
    errors.date = translate("resources.gametips.validation.date");
  }
  if (
    !values.content ||
    values.content.trim() === "" ||
    values.content === "<p><br></p>"
  ) {
    errors.content = translate("resources.gametips.validation.content");
  }
  return errors;
};



// WEBPACK FOOTER //
// ./src/containers/CRM/GameTips/validations.js